module.exports = __webpack_public_path__ + "static/favicon-f15c07fbc781f4bca46d96be94b8fbf1.ico";